module.exports = __webpack_public_path__ + "static/media/coming-soon-image.34696b55.jpg";